import styled from 'styled-components';

export const FilePreviewOriginalWrapper = styled.div`
    height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

export const StyledFilePreviewInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    padding: 32px 16px;
    background: #FFFFFF;
    height: 100%;
`;